// Fixed Asset Types Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get fixedAssetTypesList from backend then update fixedAssetTypesList in vuex store ***** //
export const updateFixedAssetTypesList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('asset_types_index', { params: params })
    commit('updateFixedAssetTypesList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch FixedAssetType from backend ***** //
export const fetchFixedAssetTypeInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`asset_types_show/${payload}`)
    commit('fetchFixedAssetTypeInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add FixedAssetType  ***** //
export const addFixedAssetType = async (ignored, payload = null) => {
  try {
    await Axios.post('asset_types_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update FixedAssetType  info ***** //
export const updateFixedAssetTypeInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`asset_types_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete FixedAssetType  ***** //
export const deleteFixedAssetType = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`asset_types_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

// ***** Get fullFixedAssetTypesList from backend then update fullFixedAssetTypesList in vuex store ***** //
export const updateFullFixedAssetTypesList = async ({ commit }) => {
  try {
    const result = await Axios.get('asset_types_list')
    let list = result.data.data
    let fullList = []
    list.forEach(pt => {
      fullList.push({
        value: pt.product_type_id,
        text: pt.asset_type_name
      })
    })
    commit('updateFullFixedAssetTypesList', fullList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
